var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M23.064 6.845a.966.966 0 00-.902 1.198l20.872 84.48a.966.966 0 001.606.464l62.783-60.399a.966.966 0 00-.401-1.624L23.366 6.882a.966.966 0 00-.302-.037zM24.438 9.2l80.44 23.157-60.37 58.077-20.07-81.234z",
    fontFamily: "sans-serif"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M64.9 18.886a.966.966 0 00-.654.27L32.869 49.361a.966.966 0 00.402 1.624l41.803 12.048a.966.966 0 001.205-1.16L65.853 19.62a.966.966 0 00-.954-.734zm-.52 2.822l9.623 39.007-38.589-11.123L64.38 21.708z",
    fontFamily: "sans-serif"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M49.327 33.835a.966.966 0 00-.9 1.196l5.176 20.988a.966.966 0 001.608.465l15.587-15.021a.966.966 0 00-.403-1.624L49.63 33.872a.966.966 0 00-.303-.037zm1.374 2.354l17.552 5.043L55.077 53.93l-4.376-17.74z",
    fontFamily: "sans-serif"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M44.164 12.869a.966.966 0 00-.655.27L27.922 28.168a.966.966 0 00.402 1.624l20.766 5.967a.966.966 0 001.205-1.16l-5.177-20.994a.966.966 0 00-.954-.735zm-.522 2.825l4.377 17.747-17.554-5.044 13.177-12.703zM85.7 24.838a.966.966 0 00-.653.27L69.457 40.13a.966.966 0 00.405 1.622l20.764 5.967a.966.966 0 001.205-1.16l-5.177-20.987a.966.966 0 00-.954-.734zm-.52 2.824l4.377 17.74-17.553-5.044L85.18 27.662zM54.524 54.844a.966.966 0 00-.653.27l-15.59 15.02a.966.966 0 00.405 1.624l20.772 5.967a.966.966 0 001.204-1.16l-5.184-20.987a.966.966 0 00-.954-.734zm-.52 2.823l4.382 17.74-17.558-5.042 13.176-12.698z",
    fontFamily: "sans-serif"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.956 114.7c-.452 1.041-1.306 1.494-2.118 1.494-1.027 0-1.989-.747-1.989-2.248v-5.32h4.316v-1.371h-4.316v-3.741l-1.522-.108v3.849h-1.644v1.371h1.644v5.32c0 2.377 1.73 3.748 3.533 3.748 1.32 0 2.692-.71 3.46-2.376zm12.76 1.537v-4.107c0-2.542-1.063-5.155-3.698-5.155-1.264 0-2.585.581-3.08 1.479v-4.94l-1.516-.108v14.008h1.515v-7.338c.453-.897 1.092-1.58 2.334-1.58 1.795 0 2.822 1.451 2.822 3.246v5.672h1.73c-.108-.366-.108-.79-.108-1.177zm11.717-7.317l.94-1.472c-1.148-.452-1.536-.473-1.923-.473-.79 0-2.391.129-3.102 1.479 0-.237.15-1.006.28-1.2h-3.741v1.135l2.075.108v7.675h-3.145v1.242h7.74c-.107-.366-.107-.79-.107-1.177v-.065h-3.016v-5.837c.345-1.522 2.269-2.355 4-1.415zm7.697-1.945c-2.908 0-4.43 1.902-4.509 5.176v.92c0 2.692 1.924 4.623 4.595 4.623 1.501 0 2.887-.646 3.87-1.716l-.897-1.112c-1.156 1.112-2.118 1.436-3.016 1.436-1.795 0-3.058-1.329-3.058-3.232l7.252-.043.021-.876c.13-3.295-1.371-5.176-4.258-5.176zm2.657 4.724h-5.65c.085-2.09.875-3.396 2.842-3.396 1.968 0 2.908 1.22 2.808 3.396zm9.104-4.724c-2.908 0-4.43 1.902-4.516 5.176v.92c0 2.692 1.924 4.623 4.602 4.623a5.265 5.265 0 003.87-1.716l-.897-1.112c-1.156 1.112-2.118 1.436-3.016 1.436-1.795 0-3.058-1.329-3.058-3.232l7.252-.043.021-.876c.13-3.295-1.371-5.176-4.258-5.176zm2.65 4.724h-5.644c.086-2.09.876-3.396 2.843-3.396 1.968 0 2.908 1.22 2.8 3.396zm7.912 4.861c0 .725.41 1.134 1.135 1.134.703 0 1.113-.409 1.113-1.134 0-.71-.41-1.113-1.113-1.113-.704 0-1.135.402-1.135 1.113zm14.69-11.1c.704 0 1.114-.388 1.114-1.135 0-.71-.41-1.091-1.113-1.091-.704 0-1.113.38-1.113 1.091 0 .747.387 1.135 1.113 1.135zm-2.713 1.795v1.134l2.096.108v8.917c0 1.515-.962 2.248-1.989 2.248-.84 0-1.694-.453-2.14-1.48l-1.35.597c.769 1.694 2.14 2.376 3.469 2.376 1.795 0 3.525-1.35 3.525-3.74l.022-10.16zm13.276 4.344c-1.946-.367-2.844-.84-2.844-1.652 0-.919 1.113-1.58 2.671-1.58 1.113 0 1.86.338 2.693 1.221l.962-.962c-.747-1.07-2.111-1.651-3.827-1.651-2.348 0-3.935 1.199-3.935 3.015 0 1.587 1.22 2.506 4.15 3.102 1.774.345 2.312.66 2.312 1.35 0 1.005-1.22 1.881-2.613 1.881-1.192 0-2.262-.66-3.246-1.816l-1.026 1.048c1.048 1.386 2.434 2.14 4.25 2.14 2.463 0 4.064-1.372 4.064-3.275 0-1.543-1.048-2.333-3.611-2.821zm0 0"
  }));
};